/**
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new Quimby UI component instead:
 *
 * Import: `import { Checkbox } from '@ui/molecules/inputs';`
 *
 * Or specific path: `import { Checkbox } from '@ui/molecules/inputs/Checkbox';`
 *
 * See the new component for documentation and migration notes.
 */
import React from 'react';
import './CheckboxStyles.scss';
function Checkbox({ id, checked, onChange, onClick, label, description, className = '' }) {
    const hasDescription = !!description;
    return (React.createElement("div", { className: `checkbox-component ${className}` },
        React.createElement("div", { className: "checkbox-component__input-wrapper" },
            React.createElement("div", { className: "qmb-checkbox" },
                React.createElement("input", { type: "checkbox", id: id, checked: checked, onChange: (e) => {
                        e.stopPropagation();
                        onChange(e.target.checked);
                    }, onClick: (e) => {
                        e.stopPropagation();
                        onClick === null || onClick === void 0 ? void 0 : onClick(e);
                    } })),
            React.createElement("label", { htmlFor: id, className: `checkbox-component__label ${hasDescription ? 'checkbox-component__label--bold' : ''}` }, label)),
        description && React.createElement("p", { className: "checkbox-component__description" }, description)));
}
export default Checkbox;
